/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Validity_RangeInputs */

const en_clients_validation_validity_range = /** @type {(inputs: Clients_Validation_Validity_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validity period must be a positive integer.`)
};

const pt_br2_clients_validation_validity_range = /** @type {(inputs: Clients_Validation_Validity_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O período de validade deve ser um número inteiro positivo.`)
};

/**
* | output |
* | --- |
* | "Validity period must be a positive integer." |
*
* @param {Clients_Validation_Validity_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_validity_range = /** @type {((inputs?: Clients_Validation_Validity_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Validity_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_validity_range(inputs)
	return pt_br2_clients_validation_validity_range(inputs)
});